import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Modal, Row, Col, Button, Radio, Checkbox, Spin, Select, Tooltip, message } from "antd";

import moment from "moment";

import axios from "axios";
import { API_ERRO_TYPE_CANCEL } from "./../../../config/general";

import ModalAfastamentos from "./ModalAfastamentos";
import ModalExcecao from "./ModalExcecao";
import ModalJustificativa from "./ModalJustificativa";
import ModalObservacao from "./ModalObservacao";
import { timeCardService } from "../../../redux/services";
import { isCorelabUser, isReindexarBatidasEnabled } from "../../../helpers/auth";
import ModalAttatchments from "./ModalAttatchments";
import { UIFormSection } from "../../../components";

class ModalActions extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			tipoCalculo: this.props.tipoCalculo || "flexivel",
			outros: "",
			item: this.props.item || {},
			selecionarFeriado: false,
			feriado_id: null,
			afastamentosModalVisible: false,
			ajustesModalVisible: false,
			excecaoModalVisible: false,
			justificativaModalVisible: false,
			observacaoModalVisible: false,
			modalAttatchmentsVisible: false,

			holidays: [],
			holidaysIsLoading: false,
		}

		this._axiosCancelHolidaysToken = null;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.tipoCalculo !== this.props.tipoCalculo || JSON.stringify(prevProps.item) !== JSON.stringify(this.props.item)) {
			this.setState({
				tipoCalculo: this.props.tipoCalculo,
				item: this.props.item,
			});
		}
	}

	resetFields = () => {
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onOpen = () => {
		const { item } = this.state;

		if(item.folga) {
			this.setState({ outros: "folga", selecionarFeriado: false, holidays: [], feriado_id: null });
		} else if(item.feriado_id) {
			this.setState({ 
				outros: "feriado",
				selecionarFeriado: true,
				holidays: [{
					id: item.feriado_id,
					descricao: item.feriado.descricao,
				}],
				feriado_id: item.feriado_id
			});
		} else if(item.dia_especial) {
			this.setState({ outros: "dia_especial", selecionarFeriado: false, holidays: [], feriado_id: null });
		} else {
			this.setState({ 
				outros: '',
				selecionarFeriado: false,
				holidays: [],
				feriado_id: null 
			});
		}
	}

	fetchHolidays = (value) => {
		if (this._axiosCancelHolidaysToken) {
			this._axiosCancelHolidaysToken.cancel(
				"Only one request allowed at a time."
			);
		}

		this._axiosCancelHolidaysToken = axios.CancelToken.source();

		if (!value.trim().length) {
			this.setState({
				holidaysIsLoading: false,
				holidays: [],
			});

			return false;
		}

		this.setState({
			holidaysIsLoading: true,
		});

		let params = {
			search: value,
			ativo: 1,
			orderBy: "descricao:asc",
			cancelToken: this._axiosCancelHolidaysToken.token,
		};

		timeCardService
			.autocompleteFeriado({
				...params,
			})
			.then((response) => {
				this.setState({
					holidaysIsLoading: false,
					holidays: response.data.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					holidaysIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onHolidaySelect = (value) => {
		this.setState({
			isLoading: true,
			feriado_id: value
		});

		timeCardService.alterarFeriado({
			cartao_ponto_id: this.props.cartaoPontoId,
			feriado_id: value,
		})
		.then((response) => {
			this.setState({
				isLoading: false,
			});

			message.success("Feriado aplicado com sucesso!");

			// Callback
			this.props.onComplete(response.data.data[0]);
		})
		.catch((data) => {
			this.setState({ isLoading: false });
			Modal.error({
				title: "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	// Afastamentos
	afastamentosOpen = () => {
		this.setState({ afastamentosModalVisible: true });

		// On open screen
		this.afastamentosScreen.onOpen();
	};

	afastamentosOnClose = () => {
		this.setState({ afastamentosModalVisible: false });
	}

	afastamentosOnComplete = () => {
		this.setState({ afastamentosModalVisible: false });

		// Reload row
		this.props.reloadRow(this.props.cartaoPontoId);
		this.onClose();
	}

	// Exceção de Horário/HE
	excecaoOpen = (item) => {
		if(item.status === 'afastamento') { 
			message.error("Não é possível aplicar exceção de horário em um dia de afastamento.");
		} else {
			this.setState({ excecaoModalVisible: true });

			// On open screen
			this.excecaoScreen.onOpen();
		}

	};

	excecaoOnClose = () => {
		this.setState({ excecaoModalVisible: false });
	}

	excecaoOnComplete = () => {
		this.setState({ excecaoModalVisible: false });

		// Reload row
		this.props.reloadRow(this.props.cartaoPontoId);
		this.onClose();
	}

	// Justificativa parcial
	justificativaOpen = () => {
		this.setState({ justificativaModalVisible: true });

		// On open screen
		this.justificativaScreen.onOpen();
	};

	justificativaOnClose = () => {
		this.setState({ justificativaModalVisible: false });
	}

	justificativaOnComplete = () => {
		this.setState({ justificativaModalVisible: false });

		// Reload row
		this.props.reloadRow(this.props.cartaoPontoId);
		this.onClose();
	}

	attatchmentsOpen = () => {
		this.setState({
			modalAttatchmentsVisible: true,
		})
	}

	attatchmentsOnClose = () => {
		this.setState({ modalAttatchmentsVisible: false });
	}

	// Observação
	observacaoOpen = () => {
		this.setState({ observacaoModalVisible: true });

		// On open screen
		this.observacaoScreen.onOpen();
	};

	observacaoOnClose = () => {
		this.setState({ observacaoModalVisible: false });
	}

	observacaoOnComplete = () => {
		this.setState({ observacaoModalVisible: false });

		// Reload row
		this.props.reloadRow(this.props.cartaoPontoId);
		this.onClose();
	}

	onCalcTypeChange = (e) => {
		this.setState({
			isLoading: true,
		});

		timeCardService.alterarCalculo({
			cartao_ponto_id: this.props.cartaoPontoId,
			tipo_calculo: e.target.value,
		})
		.then((response) => {
			this.setState({
				isLoading  : false,
				data       : response.data.data,
				tipoCalculo: e.target.value,
			});

			message.success("Tipo de cálculo alterado com sucesso.");

			// Update row
			this.props.onComplete(response.data.data[0]);
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}

	onHourBankChange = (e) => {
		this.setState({
			isLoading: true,
		});

		timeCardService.alterarBancoHoras({
			cartao_ponto_id: this.props.cartaoPontoId,
			banco_horas: e.target.checked,
		})
		.then((response) => {
			this.setState({
				isLoading: false,
			});

			message.success("Banco de horas removido com sucesso.");

			// Update row
			this.props.onComplete(response.data.data[0]);
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}

	onOtherChange = (value, item) => {
		const { cartaoPontoId } = this.props;
		const { outros, selecionarFeriado } = this.state;

    if (item.status === 'afastamento') {
			if (value === 'dia_especial') value = 'dia especial';
			message.error(`Não é possível aplicar ${value} em um dia de afastamento.`);
			return;
    }

    this.setState({ isLoading: true });

    let alterarStatus;
    let sucessoMsg;
    let falhaMsg;

    switch (value) {
			case "folga":
				alterarStatus = timeCardService.alterarFolga({
					cartao_ponto_id: cartaoPontoId,
					folga: outros !== "folga",
				});
				sucessoMsg = outros === "folga" ? "Folga removida com sucesso." : "Folga aplicada com sucesso.";
				falhaMsg = "Erro ao alterar folga.";
				break;
			case "feriado":
				if(outros === "feriado") {
					timeCardService.alterarFeriado({
						cartao_ponto_id: cartaoPontoId,
						feriado: null,
					})
					.then((response) => {
						this.setState({
							isLoading: false,
							outros: "",
							holidays: [],
							feriado_id: null,
							selecionarFeriado: false,
						});

						message.success("Feriado removido com sucesso.");

						// Update row
						this.props.onComplete(response.data.data[0]);
					})
					.catch((data) => {
						this.setState({
							isLoading: false,
						});
						Modal.error({
							title  : "Ocorreu um erro!",
							content: String(data),
						});
					});

					break;
				}

				this.setState({
					isLoading: false,
					outros: outros === "feriado" ? "" : "feriado",
					selecionarFeriado: !selecionarFeriado,
				});

				break;
			case "dia_especial":
				alterarStatus = timeCardService.alterarDiaEspecial({
					cartao_ponto_id: cartaoPontoId,
					dia_especial: outros !== "dia_especial",
				});
				sucessoMsg = outros === "dia_especial" ? "Dia especial removido com sucesso." : "Dia especial aplicado com sucesso.";
				falhaMsg = "Erro ao alterar dia especial.";
				break;
			default:
				this.setState({ isLoading: false });
				return;
    }

		if (value !== 'feriado') {
			alterarStatus
				.then((response) => {
					message.success(sucessoMsg);
					this.setState({
						isLoading: false,
						outros: outros === value ? "" : value,
						holidays: [],
						feriado_id: null,
						selecionarFeriado: false,
					});
	
					// Update row
					this.props.onComplete(response.data.data[0]);
				})
				.catch((error) => {
					this.setState({ isLoading: false });
					Modal.error({
						title: "Ocorreu um erro!",
						content: falhaMsg,
					});
				});
		}
	}


	render() {
		const { visible, item } = this.props;

		const { isLoading, holidays, holidaysIsLoading } = this.state;

		const noHourBank = !!item?.contrato?.nao_usa_banco_horas;

		const actions = [
			{ key: "afastamentos", icon: "fa-user", label: "Afastamentos", onClick: this.afastamentosOpen },
			{ key: "justificativa", icon: "fa-clipboard-list", label: "Justificativa parcial", onClick: this.justificativaOpen },
			{ key: "excecao", icon: "fa-clock", label: "Exceção de Horário/HE", onClick: () => this.excecaoOpen(item) },
			{ key: "restart", icon: "fa-undo", label: "Retornar dados originais", onClick: () => this.props.restartOpen(true) },
			{ key: "reindexar", icon: "fa-sort-alt", label: "Reindexar batidas", onClick: () => this.props.reindexarBatidasOpen(), visible: isReindexarBatidasEnabled() },
			{ key: "limpar", icon: "fa-trash-alt", label: "Limpar cartão ponto", onClick: () => this.props.limparCartaoPontoOpen(), visible: isCorelabUser(), danger: true },
			{ key: "recalcular", icon: "fa-calculator", label: "Recalcular o dia", onClick: () => this.props.recalcularDiaOpen(), visible: isCorelabUser() },
			{ key: "detalhes", icon: "fa-file-alt", label: "Detalhes do cartão ponto", onClick: this.props.detailsOpen },
			{ key: "adicionar", icon: "fa-plus-square", label: "Adicionar colunas", onClick: this.props.newJoinColumn },
			{ key: "remover", icon: "fa-minus-square", label: "Remover colunas", onClick: this.props.removeBatida },
			{ key: "horario", icon: "fa-business-time", label: "Detalhes do horário", onClick: () => this.props.journeyOpen(this.props?.item?.contrato?.jornada?.uuid) },
			{ key: "anexos", icon: "fa-paperclip", label: "Anexos", onClick: this.attatchmentsOpen },
			{ key: "observacao", icon: "fa-comment-alt", label: "Observação", onClick: this.observacaoOpen },
		].filter((action) => action.visible !== false);

		const others = [
			{ key: "folga", label: "Folga" },
			{ key: "feriado", label: "Feriado" },
			{ key: "dia_especial", label: "Dia especial" },
		];

		return (
			<Modal
				visible={visible}
				title={(
					<div className="time-card-modal-header">
						<span className="time-card-modal-header-icon"><i className="fal fa-bolt" /></span>
						<div>
							<div className="time-card-modal-title">
								Ações do cartão ponto <span>[{moment(this.props.dataDia).format("DD/MM/YYYY")}]</span>
							</div>
							<div className="time-card-modal-subtitle">Selecione a ação desejada e as opções de cálculo para aplicar no cartão ponto.</div>
						</div>
					</div>
				)}
				wrapClassName="modal-scroll"
				destroyOnClose={true}
				width={920}
				onCancel={this.onClose}
				footer={(
					<Button className="btn-close" icon={<i className="far fa-times" />} onClick={this.onClose}>Cancelar</Button>
				)}
				centered
				maskClosable={false}
				className="time-card-modal time-card-actions-modal"
			>
				<Spin spinning={isLoading} indicator={<i className="fad fa-spinner-third fa-spin fa-3x"/>}>
					<Row gutter={[16, 16]}>
						<Col xs={24} md={12}>
							<UIFormSection
								icon={<i className="fal fa-list-ul" />}
								title="Ações disponíveis"
								description="Escolha a ação que deseja realizar no cartão ponto."
							>
								<ul className="time-card-actions-list">
									{actions.map((action) => (
										<li key={action.key}>
											<button type="button" className={`time-card-actions-item ${action.danger ? "is-danger" : ""}`} onClick={action.onClick}>
												<span className="time-card-actions-item-icon"><i className={`fal ${action.icon}`} /></span>
												<span className="time-card-actions-item-label">{action.label}</span>
												<i className="fal fa-chevron-right time-card-actions-item-arrow" />
											</button>
										</li>
									))}
								</ul>
							</UIFormSection>
						</Col>
						<Col xs={24} md={12}>
							<UIFormSection
								icon={<i className="fal fa-calculator" />}
								title="Tipo de cálculo"
								description="Defina como o cálculo será aplicado."
							>
								<Radio.Group onChange={this.onCalcTypeChange} value={this.state.tipoCalculo} className="time-card-actions-options">
									<Radio value="flexivel">Flexível</Radio>
									<Radio value="horista">Horista</Radio>
									<Radio value="intervalo_flexivel">Intervalo flexível</Radio>
									<Radio value="normal">Normal</Radio>
								</Radio.Group>
							</UIFormSection>
							<UIFormSection
								icon={<i className="fal fa-cog" />}
								title="Outros"
								description="Selecione opções adicionais para a ação."
							>
								<div className="time-card-actions-options">
									{others.map((option) => (
										<Checkbox
											key={option.key}
											checked={this.state.outros === option.key}
											onChange={() => this.onOtherChange(option.key, item)}
										>
											{option.label}
										</Checkbox>
									))}
									<div className="time-card-actions-option-help">
										<Checkbox
											disabled={noHourBank}
											checked={this.state.item.usa_banco_horas}
											onChange={this.onHourBankChange}
										>
											Banco de horas
										</Checkbox>
										<Tooltip title={noHourBank ? "O contrato deste funcionário não usa banco de horas." : "Define se as horas deste dia entram no banco de horas."}>
											<i className="fal fa-info-circle" />
										</Tooltip>
									</div>
								</div>
								{this.state.selecionarFeriado && (
									<Select
										className="time-card-actions-holiday"
										filterOption={false}
										placeholder="Selecione o feriado"
										notFoundContent={
											holidaysIsLoading ? (
												<Spin
													indicator={
														<i className="fad fa-spinner-third fa-spin" />
													}
												/>
											) : null
										}
										value={this.state.feriado_id}
										onSelect={this.onHolidaySelect}
										onSearch={this.fetchHolidays}
										showSearch
									>
										{holidays.map((item, index) => (
											<Select.Option key={index} value={item.id}>
												{item.descricao}
											</Select.Option>
										))}
									</Select>
								)}
							</UIFormSection>
						</Col>
					</Row>
				</Spin>
				<ModalAfastamentos
					ref={el => this.afastamentosScreen = el}
					visible={this.state.afastamentosModalVisible}
					onComplete={this.afastamentosOnComplete}
					onClose={this.afastamentosOnClose}
					dataDia={this.props.dataDia}
					empresa={this.props.empresa}
					departamento={this.props.departamento}
					funcionario={this.props.funcionario}
					dataInicial={this.props.dataInicial}
					dataFinal={this.props.dataFinal}
					cartaoPonto={this.props.item}
				/>
				<ModalExcecao
					ref={el => this.excecaoScreen = el}
					visible={this.state.excecaoModalVisible}
					onComplete={this.excecaoOnComplete}
					onClose={this.excecaoOnClose}
					dataDia={this.props.dataDia}
					empresa={this.props.empresa}
					departamento={this.props.departamento}
					funcionario={this.props.funcionario}
				/>
				<ModalJustificativa
					ref={el => this.justificativaScreen = el}
					visible={this.state.justificativaModalVisible}
					onComplete={this.justificativaOnComplete}
					onClose={this.justificativaOnClose}
					dataDia={this.props.dataDia}
					empresa={this.props.empresa}
					departamento={this.props.departamento}
					funcionario={this.props.funcionario}
					contrato={item.contrato}
					funcionario_id={item.funcionario_id}
					dataInicial={this.props.dataInicial}
					dataFinal={this.props.dataFinal}
				/>
				<ModalObservacao
					ref={el => this.observacaoScreen = el}
					visible={this.state.observacaoModalVisible}
					onComplete={this.observacaoOnComplete}
					onClose={this.observacaoOnClose}
					dataDia={this.props.dataDia}
					cartaoPontoId={this.props.item?.uuid}
				/>

				{this.state.modalAttatchmentsVisible &&				
					<ModalAttatchments
						ref={el => this.justificativaScreen = el}
						visible={this.state.modalAttatchmentsVisible}
						onClose={this.attatchmentsOnClose}
						dataDia={this.props.dataDia}
						empresa={this.props.empresa}
						departamento={this.props.departamento}
						funcionario={this.props.funcionario}
						contrato={item.contrato}
						funcionario_id={item.funcionario_id}
					/>
				}
			</Modal>
		)
	}
}

export default ModalActions;
